export default __webpack_public_path__ + "static/media/opening_gate.b3c1c357.gif";